import { signUpApi } from './signUpApi';

export const { useSignUpMutation } = signUpApi;

export { signUpApi };
